import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { isMobile, scaledHeight, toggleMobileControls } from 'utils'

class MobileFooterButtons extends Component {
    state = {
        isVisible: false
    }

    visibleTimeout = null

    componentDidMount = _ => {
        window.addEventListener("resize", this.recalcHeight)
        
        this.visibleTimeout = setTimeout(_ => {
            this.setState({
                isVisible: true
            })
        },1000)
    }

    componentWillUnmount(){
        toggleMobileControls(true)

        clearTimeout(this.visibleTimeout)

        window.removeEventListener("resize", this.recalcHeight)
    }

    recalcHeight = _ => {
        // occasionally gets stuck at weird points. possibly from keyboard?
        window.requestAnimationFrame(_ => {
            this.forceUpdate()

            setTimeout(_ => {
                this.forceUpdate()
            },1)
        })
    }

    render (){
        if(!isMobile()){
            return null
        }

        const {
            buttons,
            isForcedShut,
        } = this.props

        const {
            isVisible
        } = this.state

        let className = "mobile-only"

        if(!isVisible || isForcedShut){
            className += ' force-shut'
        }

        const buttonsToLoop = buttons.length > 2 ? [buttons[0], buttons[1]] : buttons

        return (
            <div id="mobile-footer-buttons" style={{
                top: 'calc('+scaledHeight()+'px - 134px)'
            }} className={className}>
                { buttonsToLoop.map((buttonProps, index) => {
                    return (
                        <Button 
                            noHover={true} 
                            size="big" 
                            key={index} 
                            {...buttonProps} 
                        />
                    )
                }) }
            </div>
        )
    }
}

const mapStateToProps = state => {
	return {}
}

export default connect(mapStateToProps, { })(MobileFooterButtons)